import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
import { TrophyIcon, BookOpenIcon, PlusIcon, CheckCircleIcon } from 'lucide-react';
const ReadingChallenges = () => {
  const {
    darkMode
  } = useDarkMode();
  const activeChallenges = [{
    id: 1,
    title: '2023 Reading Goal',
    current: 24,
    target: 50,
    deadline: 'Dec 31, 2023',
    color: 'indigo'
  }, {
    id: 2,
    title: 'Fantasy Explorer',
    current: 8,
    target: 10,
    deadline: 'Nov 30, 2023',
    color: 'blue'
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-12981" data-mp="1j52jq8gv21wm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12982" data-mp="1999bh1a6cukn">
        <div className="flex justify-between items-center mb-8" data-id="element-12983" data-mp="196mvqed4r8rc">
          <h1 className="text-3xl font-bold" data-id="element-12984" data-mp="148cyly7uhy33">Reading Challenges</h1>
          <button className="flex items-center px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition-colors" data-id="element-12985" data-mp="107jab3qhqh9o">
            <PlusIcon className="h-5 w-5 mr-2" data-id="element-12986" data-mp="14m099939kz94" />
            New Challenge
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-12987" data-mp="19f31ndwb22nq">
          {activeChallenges.map(challenge => {
          const percentage = Math.round(challenge.current / challenge.target * 100);
          return <div key={challenge.id} className={`p-6 rounded-xl shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-12988" data-mp="1nd01qk9ywr75">
                <div className="flex justify-between items-start mb-4" data-id="element-12989" data-mp="1sa052nffnfuk">
                  <div data-id="element-12990" data-mp="1ecbnppkkqqu9">
                    <h3 className="text-xl font-bold mb-1" data-id="element-12991" data-mp="1eexwttn45eel">
                      {challenge.title}
                    </h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-12992" data-mp="2wwpkigmpsxk">
                      Ends {challenge.deadline}
                    </p>
                  </div>
                  <div className={`p-2 rounded-full ${challenge.color === 'indigo' ? 'bg-indigo-100 text-indigo-500' : 'bg-blue-100 text-blue-600'}`} data-id="element-12993" data-mp="29kdmsxj4015h">
                    <TrophyIcon className="h-6 w-6" data-id="element-12994" data-mp="1zuu35pnko39k" />
                  </div>
                </div>

                <div className="mb-2 flex justify-between text-sm font-medium" data-id="element-12995" data-mp="1uvr3kkqd2p8z">
                  <span data-id="element-12996" data-mp="1qvh1vk9lqkzx">{challenge.current} books read</span>
                  <span data-id="element-12997" data-mp="1qsujepl6al2x">{percentage}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700" data-id="element-12998" data-mp="1lvb1nfp9nq68">
                  <div className={`h-2.5 rounded-full ${challenge.color === 'indigo' ? 'bg-indigo-500' : 'bg-blue-600'}`} style={{
                width: `${percentage}%`
              }} data-id="element-12999" data-mp="1gxsthrj2peza"></div>
                </div>
                <p className={`mt-4 text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-13000" data-mp="36bpi344b63hl">
                  {challenge.target - challenge.current} more books to reach
                  your goal!
                </p>
              </div>;
        })}
        </div>

        <h2 className="text-2xl font-bold mb-6" data-id="element-13001" data-mp="3nml32ut2e39x">Completed Challenges</h2>
        <div className={`p-6 rounded-xl shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-13002" data-mp="3skwbd13po5q1">
          <div className="flex items-center space-x-4 mb-4" data-id="element-13003" data-mp="2vv5it7ezcsmv">
            <div className="p-2 bg-green-100 text-green-600 rounded-full" data-id="element-13004" data-mp="2zvpgcc3gty9j">
              <CheckCircleIcon className="h-6 w-6" data-id="element-13005" data-mp="2zxs22jxl558g" />
            </div>
            <div data-id="element-13006" data-mp="34u0peklxs4qp">
              <h3 className="text-lg font-bold" data-id="element-13007" data-mp="34th4qw4wj28z">Summer Romance Bingo</h3>
              <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-13008" data-mp="39uwp0lz994qb">
                Completed Aug 15, 2023
              </p>
            </div>
          </div>
          <div className="flex -space-x-2 overflow-hidden" data-id="element-13009" data-mp="p2cs2o30ga7d">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className="inline-block h-8 w-8 rounded-full ring-2 ring-white dark:ring-gray-800 bg-gray-300 flex items-center justify-center text-xs font-medium" data-id="element-13010" data-mp="1y14j7sxiwa8q">
                <BookOpenIcon className="h-4 w-4 text-gray-600" data-id="element-13011" data-mp="26z6fxwa84gq7" />
              </div>)}
            <div className="inline-block h-8 w-8 rounded-full ring-2 ring-white dark:ring-gray-800 bg-gray-100 flex items-center justify-center text-xs font-medium text-gray-500" data-id="element-13012" data-mp="224aniv12rrck">
              +4
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ReadingChallenges;